import debounce from 'lodash/debounce';
import { dataLayer } from 'analytics/data-layer';
import { GAListAnalytics, ListAnalytics, Impression, ProductData } from './types';

export const getItemListFormatted = (
  analytics?: ListAnalytics,
  productFindingMethod?: string,
): GAListAnalytics => {
  if (!analytics) {
    return {
      item_list_name: productFindingMethod,
      product_finding_method: productFindingMethod,
    };
  }

  return {
    item_list_name: analytics?.page,
    item_list_id: [analytics?.format, analytics?.curation, analytics?.page]
      .filter(Boolean)
      .join('_'),
    item_list_title: analytics?.title,
    product_finding_method: analytics?.page,
  };
};

export const mapToImpression = ({
  currencyCode,
  element,
  id,
  lineNumber,
  name,
  offer,
  position,
  podType,
  price,
  listDefinitions,
  productFindingMethod,
  uom,
  categoriesNames,
  discount,
  offerId,
  brand,
  productType,
  quantity = 1,
  sponsored,
  sponsorshipId,
  isFavourite,
  availability,
}: ProductData): Impression => {
  const [categoryName, categoryName1, categoryName2, categoryName3, categoryName4] =
    categoriesNames;

  const source = sponsorshipId ? 'citrus_ad' : 'aem';

  return {
    ...getItemListFormatted(listDefinitions, productFindingMethod),
    availability: element?.dataset.productAvailability ?? availability ?? '',
    currencyCode,
    discount,
    offer,
    offer_id: offerId,
    index: position,
    price,
    product_sku: id,
    item_category: categoryName,
    item_category2: categoryName1,
    item_category3: categoryName2,
    item_category4: categoryName3,
    item_category5: categoryName4,
    item_id: lineNumber,
    item_name: name,
    item_brand: brand,
    item_variant: productType,
    sponsored: sponsored ? 'YES' : 'NO',
    sponsored_source: sponsored ? source : 'unknown',
    'pod-type': element?.dataset.productPodType ?? podType,
    quantity,
    uom,
    favourite: isFavourite ? 'YES' : 'NO',
  };
};

const SIXTY_FPS_MS = 17;
const MAX_ROW_SIZE = 6;
const MAX_DEBOUNCE_MS = SIXTY_FPS_MS * (MAX_ROW_SIZE - 1);

let productDataBuffer: ProductData[] = [];

const reportImpressions = () => {
  const impressions: Impression[] = [];

  productDataBuffer.forEach(productData => {
    impressions.push(mapToImpression(productData));
  });

  productDataBuffer = [];

  dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      currencyCode: 'GBP',
      product_finding_method: impressions[0].product_finding_method,
      item_list_name: impressions[0].item_list_name,
      item_list_id: impressions[0].item_list_id,
      item_list_title: impressions[0].item_list_title,
      items: impressions,
    },
  });
};

const reportImpressionsDebouncer = debounce(reportImpressions, SIXTY_FPS_MS, {
  maxWait: MAX_DEBOUNCE_MS,
});

export const addProductImpression = (productData: ProductData) => {
  productDataBuffer.push(productData);

  reportImpressionsDebouncer();
};
